export function formatCurrency(amount) {
  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(amount);
}
export function formatPercentage(percent) {
  if (typeof percent !== "number") {
    return "Invalid percentage";
  }
  return new Intl.NumberFormat("en-US", {
    style: "percent",
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  }).format(percent / 100);
}
export const formatNumber = (num) => {
  if (Math.abs(num) >= 1.0e9) {
    return (Math.abs(num) / 1.0e9).toFixed(2) + "B";
  }
  if (Math.abs(num) >= 1.0e6) {
    return (Math.abs(num) / 1.0e6).toFixed(2) + "M";
  }
  if (Math.abs(num) >= 1.0e3) {
    return (Math.abs(num) / 1.0e3).toFixed(2) + "K";
  }
  return num.toFixed(2);
};
export const formatWOWValue = (value) => {
  if (value === 0) {
    return value;
  }
  if (typeof value === "number" && !isNaN(value)) {
    return value.toFixed(2);
  }
  return value;
};
export const formatDate = (dateString, isIOFPB = false) => {
  const time = {
    hour: "numeric",
    minute: "numeric",
    second: "numeric",
    hour12: "false",
  };
  const options = {
    day: "numeric",
    month: "long",
    year: "numeric",
    timeZone: "UTC",
    ...(isIOFPB && time),
  };
  const date = new Date(dateString);
  return date.toLocaleDateString("en-GB", options);
};

export const formatDatePlus8Week = (dateString) => {
  const options = {
    day: "numeric",
    month: "long",
    year: "numeric",
    timeZone: "UTC",
  };
  const date = new Date(dateString);
  date.setDate(date.getDate() + 56);
  return date.toLocaleDateString("en-GB", options);
};
export const formatColumnDate = (dateString) => {
  const date = new Date(dateString);
  const day = date.getDate();
  const month = date.toLocaleString("en-GB", {
    month: "short",
    timeZone: "UTC",
  });
  const year = date.getFullYear().toString().slice(-2); // Last two digits of the year
  return `${day}-${month}-${year}`;
};

export const formatColumnValue = (str) => {
  // Handle specific cases
  if (str === "Below_Min_Count") {
    return "STR for Min Inventory";
  }
  if (str === "Stockout_Count") {
    return "STR for Stockout Risk";
  }
  // Default behavior for other strings
  return str
    ?.split("_")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
};
export const formatColumnNumber = (number, key) => {
  let formattedNumber = formatNumber(Math.abs(number));
  const isNegative = number < 0;

  switch (key) {
    case "Percentage":
      formattedNumber = isNegative
        ? `-${formattedNumber}%`
        : `${formattedNumber}%`;
      break;
    case "Dollars":
      formattedNumber = isNegative
        ? `$-${formattedNumber}`
        : `$${formattedNumber}`;
      break;
    case "Count":
      formattedNumber = isNegative
        ? `-${formattedNumber}`
        : `${formattedNumber}`;
      break;
    case "weeks":
      formattedNumber = isNegative
        ? `-${Math.abs(formattedNumber)} weeks`
        : `${Math.abs(formattedNumber)} weeks`;
      break;
    default:
      formattedNumber = isNegative
        ? `-$${formattedNumber}`
        : `$${formattedNumber}`;
  }

  return formattedNumber;
};
